// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SeatListSeat__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/SeatListSeat.scss
 ** module id = 883
 ** module chunks = 1
 **/